export class CacheService {
  private CACHE_EXPIRY = 5 * 60 * 1000;  // 5 minutes
  private CACHE_PREFIX = 'reddit_cache_';

  getCacheKey(subreddit: string, afterParam = '') {
    return `${this.CACHE_PREFIX}${subreddit}_${afterParam}`;
  }

  getCachedData(subreddit: string, afterParam = '') {
    if (subreddit === '') return null;

    const cacheKey = this.getCacheKey(subreddit, afterParam);
    try {
      const cached = JSON.parse(localStorage.getItem(cacheKey) || '');
      if (cached && Date.now() <= cached.timestamp + this.CACHE_EXPIRY) {
        return cached.data;
      }
    } catch (e) {
      localStorage.removeItem(cacheKey);
    }
    return null;
  }

  setCachedData(subreddit: string, data: any, afterParam = '') {
    const cacheKey = this.getCacheKey(subreddit, afterParam);
    const cacheData = {
      data,
      timestamp: Date.now()
    };
    try {
      localStorage.setItem(cacheKey, JSON.stringify(cacheData));
    } catch (e) {
      this.clearRedditCache();
      try {
        localStorage.setItem(cacheKey, JSON.stringify(cacheData));
      } catch (e) {
        console.error('Failed to cache data even after cleanup:', e);
      }
    }
  }

  clearRedditCache() {
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const key = localStorage.key(i);
      if (key?.startsWith(this.CACHE_PREFIX)) {
        localStorage.removeItem(key);
      }
    }
  }
}
